export default "__VITE_ASSET__dcfd4c62__"